import { render, staticRenderFns } from "./BlInvoiceFreightPop.vue?vue&type=template&id=0b6f32bd"
import script from "./BlInvoiceFreightPop.vue?vue&type=script&lang=js"
export * from "./BlInvoiceFreightPop.vue?vue&type=script&lang=js"
import style0 from "./BlInvoiceFreightPop.vue?vue&type=style&index=0&id=0b6f32bd&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6f32bd')) {
      api.createRecord('0b6f32bd', component.options)
    } else {
      api.reload('0b6f32bd', component.options)
    }
    module.hot.accept("./BlInvoiceFreightPop.vue?vue&type=template&id=0b6f32bd", function () {
      api.rerender('0b6f32bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/BlInvoiceFreightPop.vue"
export default component.exports